<template>
  <a-card :bordered="false" :loading="loading" v-if="loading"> Loading </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <label
          >Return to the previous page and make the selection manifest
          again!</label
        >
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card class="margin-bottom" :loading="loading">
            <div slot="title">Project Manifest</div>
            <div slot="extra">
              <!-- <a-popover v-if="availableRevise" trigger="click" placement="bottom"> -->
              <a-popover v-if="(isFc || availableRevise) && (data.header.status=='Aktif' || data.header.status=='Revised')" trigger="focus" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li>
                      <a-button
                        v-if="availableRevise"
                        :disabled="!availableRevise"
                        type="dashed"
                        icon="edit"
                        class="width-full"
                        @click="handleEdit()"
                        >Edit</a-button>
                      <a-button
                        v-if="isFc"
                        type="danger"
                        icon="close-square"
                        class="width-full margin-top"
                        :loading="loading_close"
                        @click="handleCloseTrans()"
                      >Close</a-button>
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>
              <!-- <a-button v-else type="default" @click="$router.go(-1)">
                Go Back
                <a-icon type="rollback" />
              </a-button> -->
            </div>
            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li v-if="data.header.no_notif">
                  <span class="m-list-title" for>Sales Notification Number</span>
                  <span class="m-list-desc">{{
                    data.header.no_notif?data.header.no_notif:'-'
                  }}</span>
                </li>
                <li v-if="data.header.deskripsi_notif">
                  <span class="m-list-title" for>Sales Notification Description</span>
                  <span class="m-list-desc">{{
                    data.header.deskripsi_notif?data.header.deskripsi_notif:'-'
                  }}</span>
                </li>
                <li v-if="data.header.no_prospek">
                  <span class="m-list-title" for>Prospect No.</span>
                  <span class="m-list-desc">{{
                    data.header.no_prospek?("["+data.header.no_prospek+"] "+data.header.prospek_customer+" | "+data.header.prospek_description):"-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Project Code</span>
                  <span class="m-list-desc">{{
                    data.header.kode_proyek
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Project Name</span>
                  <span class="m-list-desc">{{ data.header.nama_project }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Project Directorate</span>
                  <span class="m-list-desc">{{ data.header.project_direktorat ? data.header.project_direktorat : '-' }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Project Department</span>
                  <span class="m-list-desc">{{ data.header.project_departmen ? data.header.project_departmen : '-' }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Customer Name</span>
                  <span class="m-list-desc">{{ data.header.klien }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Budget Type</span>
                  <span class="m-list-desc">{{ data.header.jns_anggaran }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Company</span>
                  <span class="m-list-desc">{{ data.header.bendera }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Executor Site</span>
                  <span class="m-list-desc">{{ data.header.site }}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Status</span>
                  <span class="m-list-desc">{{ data.header.status=='Non Aktif' ? 'Closed' : data.header.status }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header.tlc_create
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Operator Authority (PIMPRO)</span>
                  <span class="m-list-desc">{{ data.header.pimpinan_proyek }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Directorate</span>
                  <span class="m-list-desc">{{ data.header.pic_direktorat ? data.header.pic_direktorat : '-' }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Department</span>
                  <span class="m-list-desc">{{ data.header.pic_departmen ? data.header.pic_departmen : '-' }}</span>
                </li>
                <li v-if="data.header.account_manager">
                  <span class="m-list-title" for>Marketing/IBD</span>
                  <span class="m-list-desc">{{
                    data.header.account_manager
                  }}</span>
                </li>
                <li v-if="data.header.pic_ga">
                  <span class="m-list-title" for>General Affair</span>
                  <span class="m-list-desc">{{ data.header.pic_ga ? data.header.pic_ga : '-' }}</span>
                </li>
                <li v-if="data.header.pic_finance">
                  <span class="m-list-title" for>Finance</span>
                  <span class="m-list-desc">{{ data.header.pic_finance ? data.header.pic_finance : '-' }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.dt_create).format("DD-MM-YYYY")
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.catatan
                      ? data.header.catatan
                      : "Tidak Ada Catatan"
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <!-- <a-card
            :loading="loading"
            :class="getScreen ? 'margin-top' : 'margin-bottom'"
            v-if="data.informasi_rab !== null && rabview && isRabExist"
          >
            <div slot="title">RAB Information</div>
            <a-popover slot="extra" trigger="focus" placement="bottom">
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a
                    class="m-display-block"
                    @click="visibleDtlToggle('Marketing')"
                    >Marketing</a
                  >
                </li>
                <li>
                  <a
                    class="m-display-block"
                    @click="visibleDtlToggle('Produksi')"
                    >Production</a
                  >
                </li>
                <li>
                  <a
                    class="m-display-block"
                    @click="visibleDtlToggle('Implementasi')"
                    >Implementation</a
                  >
                </li>
                <li>
                  <a class="m-display-block" @click="visibleDtlToggle('GA')"
                    >GA</a
                  >
                </li>
              </ul>
              <a-button icon="more">Usage</a-button>
            </a-popover>

            <div class="m-card-body">
              <template v-if="getScreen">
                <a-list :dataSource="data.informasi_rab">
                  <a-list-item
                    class="m-display-flex flex-row"
                    slot="renderItem"
                    slot-scope="item, index"
                  >
                    <a-card
                      class="m-flex1"
                      :title="
                        item.title
                          ? item.title.charAt(0).toUpperCase() +
                            item.title.slice(1)
                          : item.title
                      "
                    >
                      <div>
                        <span class="m-display-block m-text-bold"
                          >Total Budget</span
                        >
                        <span>{{ formatRupiah(item.anggaran) }}</span>
                      </div>
                      <div>
                        <span class="m-display-block m-text-bold"
                          >Total Allocation</span
                        >
                        <span>{{ formatRupiah(item.pemakaian) }}</span>
                      </div>
                      <div>
                        <span class="m-display-block m-text-bold"
                          >Allocation Budget</span
                        >
                        <span>{{ formatRupiah(item.sisa) }}</span>
                      </div>
                    </a-card>
                  </a-list-item>
                </a-list>
              </template>
              <a-table
                :pagination="false"
                bordered
                v-else
                :columns="columnRab"
                :dataSource="data.informasi_rab"
                :scroll="{ x: true }"
              >
                <h4 slot="dataTitle" slot-scope="item" class="margin-remove">
                  {{
                    item.title
                      ? item.title.charAt(0).toUpperCase() + item.title.slice(1)
                      : item.title
                  }}
                </h4>
                <span slot="anggaran" slot-scope="text">{{
                  formatRupiah(text)
                }}</span>
                <span slot="pemakaian" slot-scope="text">{{
                  formatRupiah(text)
                }}</span>
                <span slot="realization" slot-scope="text">{{
                  formatRupiah(text)
                }}</span>
                <span slot="trealization" slot-scope="text">
                  <CurrencyJustified currencyValue="IDR" :valueNumber="text" />
                </span>
                <span slot="sisa" slot-scope="text">
                  <CurrencyJustified currencyValue="IDR" :valueNumber="text" />
                </span>
              </a-table>
              <div class="m-price-total" :class="getScreen ? 'mobile' : ''">
                <a-statistic
                  title="Total Budget :"
                  :value="formatRupiah(data.total_rab[0].total_anggaran)"
                  class="m-text-align left"
                />
                <a-statistic
                  title="Total Allocation :"
                  :value="formatRupiah(data.total_rab[0].total_pemakaian)"
                  class="m-text-align left"
                />
                <a-statistic
                  title="Total Realization :"
                  :value="formatRupiah(data.total_rab[0].total_realisasi)"
                  class="m-text-align left"
                />
                <a-statistic
                  title="Total Allocation Budget :"
                  :value="formatRupiah(data.total_rab[0].total_sisa)"
                  class="m-text-align textbold left"
                />
                <a-statistic
                  title="Total Realization Budget:"
                  :value="formatRupiah(data.total_rab[0].total_sisa_realisasi)"
                  class="m-text-align textbold left"
                />
              </div>
            </div>
          </a-card> -->

          <a-card
            class="margin-top"
            v-if="data.jenis=='Approve'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option
                    v-for="item in data.aksi"
                    :key="item.aksi"
                    >{{ item.aksi }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  :loading="loadingaction"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status
                    :status="
                      data.header.status == 'Revised' &&
                      data.header.cancel_sts == 1
                        ? 'Canceled'
                        : (data.header.status=='Non Aktif' ? 'Closed' : data.header.status)
                    "
                  />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Creator - {{ data.header.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.header.dt_create).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.header.remark">{{
                      data.header.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <!-- a-card
            :loading="loading"
            :class="getScreen ? 'margin-top' : 'margin-bottom'"
          >
            <div slot="title">Contract Documents</div>
            <div>
              <a-alert
                v-if="data.dokumen_kontrak.length <= 0"
                type="error"
                message="No contract documents uploaded"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_kontrak"
                v-else
              >
                <Empty
                  v-if="
                    data.dokumen_kontrak
                      ? data.dokumen_kontrak.length <= 0
                      : data.dokumen_kontrak
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h4 class="margin-remove m-list-dots">{{ item.nama }}</h4>
                      <a-button
                        v-if="item.nama !== null || item.nama !== undefined"
                        @click="handleViewDokumen(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-card
            :loading="loading"
            :class="getScreen ? 'margin-top' : ''"
            v-if="data.informasi_rab"
          >
            <div slot="title">Contract Details Information</div>

            <div class="m-card-body">
              <a-alert
                v-if="data.informasi_detail_kontrak <= 0"
                type="error"
                message="There are no contract details available!"
                showIcon
              />
              <ul class="m-list-wrapper bordered" v-else>
                <li
                  v-for="(item, index) in data.informasi_detail_kontrak"
                  :key="index"
                  class="margin-remove"
                >
                  <h4>{{ item.nama_produk }}</h4>
                  <span>{{ item.jumlah + " " + item.satuan }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card
            :loading="loading"
            :class="getScreen ? 'margin-top' : 'margin-top'"
          >
            <div slot="title">Project Closing Document</div>
            <a-button
              slot="extra"
              icon="upload"
              v-if="data.jenis !== 'Manifest'"
              @click="showDrawer"
              type="link"
              >Add</a-button
            >

            <div class="m-card-body">
              <a-alert
                v-if="data.dokumen_closing.length <= 0"
                type="error"
                message="There are no documents available!"
                showIcon
              />
              <a-list
                itemLayout="vertical"
                :dataSource="data.dokumen_closing"
                :pagination="pagination"
                v-else
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <a-row slot="title" type="flex" justify="space-between">
                      <a href="#">{{ item.deskripsi_doc }}</a>
                    </a-row>
                    <div slot="description">
                      <ul class="m-list-wrapper">
                        <div class="m-display-flex space-between margin-remove">
                          <span class="m-text-bold">{{
                            item.tanggal + " | " + item.tlc
                          }}</span>
                          <div class="m-display-flex">
                            <small
                              class="margin-remove m-text-align right m-text-ellipse"
                              >{{ item.nama }}</small
                            >
                          </div>
                        </div>
                      </ul>
                    </div>
                  </a-list-item-meta>

                  <a-button-group>
                    <a-button
                      @click="handleRemove(item.id_project_doc)"
                      type="danger"
                      icon="close"
                      v-if="data.jenis !== 'Manifest'"
                      >Remove</a-button
                    >
                    <a-button
                      @click="handleDownload(item)"
                      type="primary"
                      icon="download"
                      >Unduh</a-button
                    >
                  </a-button-group>
                </a-list-item>
              </a-list>
            </div>

            <template
              v-if="data.jenis !== 'Manifest'"
              class="ant-card-actions"
              slot="actions"
            >
              <a-button type="danger" @click="handleClose" block
                >Close the project</a-button
              >
            </template>
          </a-card-->
        </a-col> 

        <a-modal
          :maskClosable="false"
          :width="1200"
          centered
          :title="dataRabVisibleDtl.title + ' Usage'"
          :visible="rabVisibleDtl"
          @cancel="hideModal"
          :footer="null"
          class="mis-modal"
        >
          <a-input-search
            class="margin-bottom"
            v-model="search"
            placeholder="Quick Search"
          />
          <a-list
            v-if="getScreen"
            :loading="loadingModal"
            :dataSource="searchbox.data"
            item-layout="vertical"
            :pagination="pagination"
          >
            <a-list-item
              class="m-display-flex flex-row"
              slot="renderItem"
              slot-scope="item"
            >
              <a-card class="m-flex1">
                <div class="header-custom">
                  <div class="margin-bottom-small">
                    <div class="m-display-flex space-between">
                      <h4 class="margin-remove">{{ item.jenis }}</h4>
                      <Status :status="item.status" />
                    </div>
                    <small>{{ item.no }}</small>
                  </div>
                </div>
                <span class="margin-remove m-list-desc">{{
                  item.deskripsi ? item.deskripsi : "Tidak Ada Catatan"
                }}</span>
                <a-divider
                  class="margin-bottom-small margin-top-small"
                ></a-divider>
                <div>
                  <span class="m-display-block">Value</span>
                  <span class="m-text-bold">{{
                    formatCurrency(item.currency, item.value)
                  }}</span>
                </div>
                <div>
                  <span class="m-display-block">Realisasi</span>
                  <span class="m-text-bold">{{
                    formatCurrency(item.currency, item.realisasi)
                  }}</span>
                </div>
              </a-card>
            </a-list-item>
          </a-list>
          <div
            v-if="getScreen"
            class="m-price-total"
            :class="getScreen ? 'mobile' : ''"
          >
            <a-statistic
              title="Total Budget :"
              :value="
                formatCurrency(
                  dataRabVisibleDtl.data.currency,
                  dataRabVisibleDtl.data.total_anggaran
                )
              "
              class="m-text-align left"
            />
            <a-statistic
              title="Total Allocation :"
              :value="
                formatCurrency(
                  dataRabVisibleDtl.data.currency,
                  searchbox.totalallocation
                )
              "
              class="m-text-align left"
            />
            <a-statistic
              title="Total Realization :"
              :value="
                formatCurrency(
                  dataRabVisibleDtl.data.currency,
                  searchbox.totalrealisasi
                )
              "
              class="m-text-align left"
            />
          </div>
          <a-table
            v-if="!getScreen"
            bordered
            :scroll="{ x: true }"
            :pagination="pagination"
            size="small"
            :loading="loadingModal"
            :columns="columnModal"
            :dataSource="searchbox.data"
          >
            <a
              @click="handleView(item, true)"
              slot="deskripsi"
              slot-scope="item"
            >
              <h4 class="margin-remove">{{ `${item.jenis} (${item.no})` }}</h4>
              <small>{{ item.deskripsi }}</small>
            </a>
            <Status
              slot="status"
              slot-scope="item"
              :status="item.keterangan ? item.keterangan : item.status"
              class="margin-remove"
            />\
            <span slot="value" slot-scope="item">{{
              formatCurrency(item.currency, item.value)
            }}</span>
            <span slot="realization" slot-scope="item">{{
              formatCurrency(item.currency, item.realisasi)
            }}</span>

            <template slot="footer">
              <div class="m-price-total">
                <a-statistic
                  title="Total Budget :"
                  :value="
                    formatCurrency(
                      dataRabVisibleDtl.data.currency,
                      dataRabVisibleDtl.data.total_anggaran
                    )
                  "
                  class="m-text-align left"
                />
                <a-statistic
                  title="Total Allocation :"
                  :value="
                    formatCurrency(
                      dataRabVisibleDtl.data.currency,
                      searchbox.totalallocation
                    )
                  "
                  class="m-text-align left"
                />
                <a-statistic
                  title="Total Realization :"
                  :value="
                    formatCurrency(
                      dataRabVisibleDtl.data.currency,
                      searchbox.totalrealisasi
                    )
                  "
                  class="m-text-align left"
                />
              </div>
            </template>
          </a-table>
        </a-modal>
      </a-row>
    </div>
    <a-drawer
      title="Upload Document"
      placement="bottom"
      height="310"
      :closable="false"
      @close="onClose"
      :visible="uploadVisible"
    >
      <a-form :form="form">
        <a-form-item label="Document Description">
          <a-input
            v-decorator="['deskripsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Upload Document File">
          <a-upload
            :showUploadList="true"
            :fileList="push"
            :beforeUpload="beforeUpload"
            v-decorator="[
              'upload',
              { rules: [{ required: true }], valuePropName: 'push' },
            ]"
          >
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            block
            @click="handleNew"
            :loading="btnLoading"
            >Add</a-button
          >
        </a-form-item>
      </a-form>
    </a-drawer>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{
              moment(history.tgl_notif).format(getDateTimeFormat)
            }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{
              moment(history.tgl_notif).format(getDateTimeFormat)
            }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import lottie from "vue-lottie";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";
import moment from "moment";
import notfound from "@/assets/anim/404.json";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
import { forEach } from "lodash";

export default {
  name: "manifestRab",
  props: ["id", "rabview"],
  components: { "m-anim": lottie, Status },
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    const columnModal = [
      {
        title: "Deskripsi",
        key: "deskripsi",
        scopedSlots: { customRender: "deskripsi" },
        sorter: (a, b) => a.jenis.length - b.jenis.length,
      },
      {
        title: "Tanggal Buat",
        key: "tanggal",
        dataIndex: "tanggal_buat",
        width: 150,
        sorter: (a, b) =>
          moment(a.tanggal_buat).unix() - moment(b.tanggal_buat).unix(),
      },
      {
        title: "Status",
        key: "status",
        width: 120,
        scopedSlots: { customRender: "status" },
        sorter: (a, b) => a.status.length - b.status.length,
      },
      {
        title: "Value",
        key: "value",
        align: "right",
        scopedSlots: { customRender: "value" },
        sorter: (a, b) => a.value - b.value,
      },
      {
        title: "Realisasi",
        key: "realization",
        align: "right",
        scopedSlots: { customRender: "realization" },
      },
    ];
    const columnRab = [
      {
        title: "Departement",
        key: "title",
        scopedSlots: { customRender: "dataTitle" },
      },
      {
        title: "Total Budget",
        key: "anggaran",
        dataIndex: "anggaran",
        scopedSlots: { customRender: "anggaran" },
      },
      {
        title: "Total Allocation",
        key: "pemakaian",
        dataIndex: "pemakaian",
        scopedSlots: { customRender: "pemakaian" },
      },
      {
        title: "Total Realization",
        key: "realisasi",
        dataIndex: "realisasi",
        scopedSlots: { customRender: "realization" },
      },
      {
        title: "Allocation Budget",
        key: "sisa",
        dataIndex: "sisa",
        scopedSlots: { customRender: "sisa" },
      },
      {
        title: "Realization Budget",
        key: "sisa_realisasi",
        dataIndex: "sisa_realisasi",
        scopedSlots: { customRender: "trealization" },
      },
    ];
    return {
      loading: true,
      loadingModal: true,
      btnLoading: false,
      loading_close: false,
      notfound: { animationData: notfound, loop: true },
      data: {
        header:{
          tlc_create: null
        }
      },
      uploadVisible: false,
      push: [],
      search: "",
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      rabVisibleDtl: false,
      dataRabVisibleDtl: {
        title: "",
        data: {
          pengeluran: "",
        },
      },
      columnRab,
      columnModal,
      isRabExist: true,
      visibleHistory: false,
      loadingaction: false,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getDefaultDateFormat",
    ]),
    searchbox() {
      let data = this.dataRabVisibleDtl.data.pengeluaran;

      if (this.search) {
        data = _.filter(
          data,
          (value) =>
            (value.jenis ? value.jenis : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.status ? value.status : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.no ? value.no : "")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (value.value ? value.value : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            (value.realisasi ? value.realisasi : "").indexOf(
              this.search.toLowerCase()
            ) >= 0 ||
            this.moment(value.tanggal_buat)
              .format(this.getDefaultDateFormat)
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      let totalallocation = 0;
      let totalrealisasi = 0;

      if (data) {
        data.forEach((list) => {
          totalallocation = totalallocation + parseFloat(list.value);
          totalrealisasi =
            totalrealisasi + parseFloat(list.realisasi ? list.realisasi : 0);
        });
      }

      return { data, totalallocation, totalrealisasi };
    },
    availableRevise() {
      return this.getAuth.username == this.data.header.tlc_create && this.data.header.status=='Revised'
    },
    isFc(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='financial control'){
          res = true
        }
      });
      return res
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  methods: {
    moment,
    async fetchManifest() {
      this.loading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "project",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header: response.data.header[0],
            dokumen_kontrak: response.data.dokumen_kontrak,
            informasi_rab: response.data.informasi_rab,
            total_rab: response.data.total,
            informasi_detail_kontrak: response.data.informasi_detail_kontrak,
            dokumen_closing: response.data.dokumen_closing,
            jenis: response.data.jenis,
            status: response.data.wf,
            history: response.data.notifikasi,
            aksi: response.data.aksi,
          };

          let tBudget = 0;
          _.forEach(response.data.informasi_rab, (item) => {
            tBudget = tBudget + parseInt(item.anggaran);
          });

          if (tBudget == 0) {
            this.isRabExist = false;
          } else {
            this.isRabExist = true;
          }

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDokumen(file) {
      const url = this.$serviceUrl + file.url;
      window.open(url, "_blank");
    },
    showDrawer() {
      this.uploadVisible = true;
    },
    onClose() {
      this.uploadVisible = false;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleNew() {
      this.confirmMessage("confirm-save");
    },
    handleNewProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.btnLoading = false;
          this.displayMessage("form-warning");
          return;
        }

        let addData = new FormData();
        addData.append("kode_proyek", this.id);
        addData.append("deskripsi_doc", values.deskripsi);
        addData.append("tlc", this.getAuth.username);
        addData.append("file_transfer", this.push[0]);

        this.btnLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "project/doc_closing",
          processData: false,
          data: addData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.btnLoading = false;
            this.uploadVisible = false;
            this.fetchManifest();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleRemove(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    delete(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      axios({
        method: "delete",
        url: serviceUrl + "project/doc_closing",
        processData: false,
        data: {
          id_project_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("refresh", true);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.confirmMessage("confirm-close");
    },
    close() {
      if (this.data.dokumen_closing.length >= 1) {
        const serviceUrl = this.$serviceUrl,
          auth = {
            username: this.getAuth.username,
            password: this.getAuth.password,
            apikey: this.getAuth.apikey,
          },
          data = new FormData();

        data.append("tlc", auth.username);
        data.append("kode_proyek", this.id);
        axios({
          method: "post",
          url: serviceUrl + "project/closing",
          processData: false,
          data: data,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-close-project");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      } else {
        this.displayMessage("warning-emptyDoc");
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    hideModal() {
      this.toggleBodyClass("removeClass", "scrollDisable");
      this.rabVisibleDtl = false;
    },
    visibleDtlToggle(item) {
      this.loadingModal = true;
      this.toggleBodyClass("addClass", "scrollDisable");

      axios({
        method: "get",
        url: this.$serviceUrl + "project/detil_rab",
        params: {
          kode_proyek: this.id,
          allocation: item.toLowerCase(),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let items = {
            title: item,
            data: JSON.parse(JSON.stringify(response.data)),
          };
          this.dataRabVisibleDtl = items;
          this.loadingModal = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
      this.rabVisibleDtl = true;
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleActionConfirm(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loadingaction = true

        let data = new FormData();
        data.append("id_manifest", this.id);
        data.append("status",values.aksi);
        data.append("remark",values.catatan);

        this.asyncAxiosPost(
          "project/approval",
          "formdata",
          this.getAuth,
          data
        )
          .then((response) => {
            this.displayMessage("success-save");
            this.loadingaction = false;
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingaction = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });
      })
    },
    handleEdit(){
      this.$router.push({
        name: "proyekrabEditAcc",
        params: {id: this.id},
      });
    },
    handleCloseTrans(){
      const that = this;
      this.$confirm({
        title: "Are you sure to Close this Project?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading_close = true;

          let data = new FormData();
          data.append("project_id", that.id);
          that.asyncAxiosPost("project/close", "formdata", that.getAuth, data)
          .then((response) => {
            console.log(response)
            that.displayMessageValue("success-other", response.message);
            that.loading_close = false;

            that.$router.go(0);
          })
          .catch((err) => {
            that.loading_close = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              that.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error", responses);
            }
          });
        },
        onCancel() { },
      });
    }
  },
  mounted() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageClose", this.close);
    Event.$on("confirmMessageReturn", this.handleNewProcess);
  },
  beforeDestroy() {
    this.toggleBodyClass("removeClass", "scrollDisable");
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageClose", this.close);
    Event.$off("confirmMessageReturn", this.handleNewProcess);
  },
};
</script>
<style lang="less">
.ant {
  &-modal {
    top: 12px !important;
  }
  &-table {
    &-footer {
      padding: 0;
    }
  }
  &-list-item {
    &-content {
      margin-bottom: 0 !important;
    }
  }
}
.m-price-total {
  margin: 0 !important;
  text-align: right;

  &.mobile {
    .ant-statistic-content {
      font-size: 14px;
      font-weight: 600;
    }
  }
}
.textbold {
  font-weight: bold;
}
</style>